<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="30%" :before-close="handleClose">
        <el-form label-width="80px" >
            <el-checkbox-group  style="text-align: left" v-model="settingData" >
                <el-checkbox :label="item.Name" v-for="(item,index) in settingList" :key="index" style="display: block;margin-bottom: 10px" 
                 @change="checked=>handleChange(checked,item.OID)"  :ref="`settingList${`checkbox` + item.OID}`" ></el-checkbox>
            </el-checkbox-group>
        </el-form>
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination background @current-change="handleCurrentChange" :current-page="model.Page" layout="total,prev, pager, next, jumper" :total="listCount" :page-size="model.Rows">
            </el-pagination>
        </el-row>
    </el-dialog>
</template>

<script>
import {GetDeviceSettingList,DeleteDeviceSetting,AddDeviceSetting} from '../../api/device'
import {GetSettingsList} from '../../api/setting'
export default {
    data() {
        return {
            title: '设备配置项',
            name: 'add',
            DeviceID: null,
            deviceSettingList: [],
            settingList: [],
            settingData: [],
            model: {
                Page: 1,
                Rows: 15,
                SearchKey: '',
            },
            listCount: null,
            cusDisabled: false,
            
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        OID: {
            required: true
        }
    },  
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.DeviceID = this.OID;
            this.GetSettingsList();
        },
        handleChange(val,SettingsID) {
            let _this = this;
            if(val) {
                AddDeviceSetting({DeviceID:this.DeviceID,SettingsID:SettingsID}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                    }
                }).catch((error)=>{
                    _this.settingData = _this.settingData.filter((item,index)=>{
                        return item.indexOf('人脸') < 0;
                    })
                })
            }else{
                DeleteDeviceSetting({DeviceID:this.DeviceID,SettingsID:SettingsID}).then(data=>{
                    console.log(1,data)
                    if(!data.iserror) {
                        this.$message({
                            message: '已删除',
                            type: 'success'
                        });
                    }
                }).catch((error)=>{
                    console.log(_this.settingData)
                })
                
            }
        },
        handleClose() {
            this.$emit('closeSettingDialog')
        },
        GetDeviceSettingList() {
            let arr = [];
            GetDeviceSettingList({DeviceID: this.DeviceID}).then(data=>{
                if(!data.iserror) {
                    this.deviceSettingList = data.data.List;
                    this.settingList.forEach(m=>{
                        this.deviceSettingList.forEach(n=>{
                            if(m.OID == n.SettingsID) {
                                this.settingData.push(n.SettingName)
                            }
                        })
                    })
                }
            })
        },
        GetSettingsList() {
            GetSettingsList(this.model).then(data=>{
                if(!data.iserror) {
                    if(data.data.List.length!=0) {
                        this.settingList = data.data.List;
                        this.listCount = data.data.Count;
                        this.GetDeviceSettingList();
                    }
                }
            }) 
        },
        handleCurrentChange(val) {
            this.model.Page = val;
            this.GetSettingsList();
        },
    }
}
</script>

<style>

</style>